import { render, staticRenderFns } from "./Favourites_modal.vue?vue&type=template&id=7c335ff0"
import script from "./Favourites_modal.vue?vue&type=script&lang=js"
export * from "./Favourites_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports